import React from 'react';
import { AppService } from '@aperza/util';
import clsx from 'clsx';
import style from './EnvironmentIndicator.module.scss';
const appConfig = AppService.appConfig();
// TODO : remove app-search EnvironmentIndicator when migration is completed
export default function EnvironmentIndicator() {
    return (React.createElement("span", { style: style, className: clsx(style.envBalloon, { [style[`${appConfig.env}`]]: appConfig.env }) }, `${appConfig.serviceType}-${appConfig.env}`));
}
